import React from 'react';
import Menu from '../nav/menu';
import Footer from '../nav/footer';
import Button from '@mui/material/Button';
import { 
    headerText,
    bodyText,
    buttonText,
    secondDivText,
    buttonTextSubscribe
 } from './styles';

import SpecialtyCoffeMain from '../components/specialtyCoffee';
import CarroucelMain from '../components/carroucelMain';
import CoffeComponent from '../components/coffee';
import StylishHeader from '../components/stylishHeader';
import OurFarmsComponent from '../components/ourFamrsComponents.js';
import OurProvidersList from '../components/ListOurProviders.js';
import { generalStyleDivs } from '../styles.js';
import { Link } from 'react-router-dom';
import { textNormalSize, textInResolution } from '../multiFunctions';

function MainPageDesktop(props) {
    /* eslint-disable react/prop-types */
    const isLargeScreen = props.isLargeScreen;
    const isSmallScreen = props.isSmallScreen;
    const screenWidthSize = window.screen.width;
    let screenSize = {
        width: window.screen.width,
        height: window.screen.height
    }

    let urlWorkingMan = "/img/mainPage/coffeeWorkingMan1024x640.jpg";
    if (screenWidthSize >= 1440) {
        urlWorkingMan = "/img/mainPage/coffeeWorkingMan1440x900.jpg";
    }

    let textSizeForBanner = {
        fontSize: textInResolution('xx-large', 'xx-large', 'xxx-large', 'xxx-large', screenSize)
    }
    let textSizeForBanner2 = {
        fontSize: textInResolution('large', 'large', 'x-large', 'x-large', screenSize)
    }
    let flotingTextStyle = {
        position: "absolute",
        top: "65%",
        left: "5%",
        color: "white",
        textAlign: "left",
        maxWidth: "90%"
    }
    let textStyle2 = textNormalSize;
    return (
        <div style={{ backgroundColor: "#F4DFBB"  }}>
            <Menu/>
            <div style={{ display: "block" }}>
                <div id="mainArea" style={{ justifyContent: "center", display: "flex" }}>
                    <div style={{ maxWidth: "1200px", backgroundImage: "url(./img/backgroundSite.png)", backgroundRepeat: "repeat" }}>
                        <div id="bannerArea" style={{ width: "100%", position: "relative" }}>
                            <img src={urlWorkingMan} style={{ width: "100%", display: "block", height: "auto" }} alt='' />
                            <div style={{ ...flotingTextStyle }}>
                                <span style={{ ...textSizeForBanner }}>{headerText}</span><br/><br/>
                                <span style={{ ...textSizeForBanner2, textAlign: "-webkit-center" }}>{bodyText}</span><br/><br/>
                                <Button variant="contained" sx={{ borderRadius: "30px", backgroundColor: "white", color: "black" }} >{buttonText}</Button>
                                <Link to="/newsletter">
                                    <Button variant="contained" sx={{ borderRadius: "30px", backgroundColor: "white", color: "black", marginLeft: "20px" }}>{buttonTextSubscribe}</Button>
                                </Link>
                            </div>
                        </div>
                        <StylishHeader headerText="More about us" />
                        <CarroucelMain fontSize={textStyle2} />
                        <SpecialtyCoffeMain isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} fontSize={textStyle2}/>
                        <OurProvidersList isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} fontSize={textStyle2}/>
                        <StylishHeader headerText="Our type of toast" />
                        <CoffeComponent/>
                        <OurFarmsComponent isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} />
                        <StylishHeader headerText="More about our farms"/>
                        <div style={{ display: "flex", justifyContent: "space-around", flexFlow: "row wrap", paddingBottom: '10px' }}>
                            <div style={{   width: "97%", 
                                            height: "100%",
                                            display: "flex",
                                            ...generalStyleDivs
                                        }}>
                                <div style={{ width: "70%", display: "flex",justifyContent: "center", alignItems: "center" }}>
                                    <img src="/img/mainImageFincasCafe.jpg" style={{ borderRadius: "30px", width: "90%",height: "90%" }} alt=''/>
                                </div>
                                <div style={{ width: "30%", padding: "10px", display: 'flex', lineHeight: "1.7", alignItems: 'center'}} dangerouslySetInnerHTML={{ __html: secondDivText }}>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default MainPageDesktop;